<template>

    <div id="app" class="app">
        <v-app>
            <Navigation :loggedIn="loggedIn"
                        :poolRead="poolRead"
                        :poolGroupRead="poolGroupRead"
                        :userRead="userRead"
                        :roleRead="roleRead"
                        :protocolRead="protocolRead"
                        :settingRead="settingRead"
                        :username="username"
                        :name="name"/>
            <router-view></router-view>
        </v-app>
    </div>

</template>

<script>
    import Navigation from './components/Navigation.vue'
    import auth from './auth'
    import {EventBus} from "./eventbus";

    export default {
        name: 'app',
        components: {
            Navigation
        },

        data: () => ({
            loggedIn: auth.loggedIn(),
            poolRead: false,
            poolGroupRead: false,
            userRead: false,
            roleRead: false,
            protocolRead: false,
            settingRead: false,

            username: '',
            name: ''
        }),

        methods: {
            initializeRights() {
                this.resetRights();

                let rights = JSON.parse(this.$cookies.get("userRights"));

                if (rights !== null) {
                    rights.forEach(right => {
                        if (right.right === "PoolGroupRead" || right.right === "PoolModify") {
                            this.poolRead = true;
                        }

                        if (right.right === "PoolGroupRead" || right.right === "PoolGroupModify") {
                            this.poolGroupRead = true;
                        }

                        if (right.right === "UserRead") {
                            this.userRead = true;
                        }

                        if (right.right === "RoleRead") {
                            this.roleRead = true;
                        }

                        if (right.right === "ProtocolEntryRead" || right.right === "ProtocolEntryReadAll") {
                            this.protocolRead = true;
                        }

                        if (right.right === "SettingRead" || right.right == "SystemSettingRead") {
                            this.settingRead = true;
                        }
                    });
                }
            },

            resetRights() {
                this.poolRead = false;
                this.poolGroupRead = false;
                this.userRead = false;
                this.roleRead = false;
                this.protocolRead = false;
                this.settingRead = false;
            },

            initializeUserInfo() {
                this.name = "";
                this.username = "";

                let user = this.$cookies.get('currentUser');

                if (user !== null) {
                    this.name = user.firstname + " " + user.lastname;
                    this.username = "@" + user.username;
                }
            }
        },

        mounted() {
            EventBus.$on('refreshNavigationBar', () => {
                this.initializeRights();
                this.initializeUserInfo();
            })
        },

        created() {
            auth.onChange = async loggedIn => {
                this.loggedIn = loggedIn;
                if (!loggedIn) {
                    await EventBus.$emit('userTokenExpired');
                    this.$router.push("/login");
                }
            };

            this.initializeUserInfo();
            this.initializeRights();
        }
    }
</script>

<style>

    #app {
        text-align: center;
        background-color: #FFFFFF;
        margin-top: 20px;
        margin-left: 10px;
        margin-right: 10px;
        min-height: 0px;
    }

    .application--wrap {
        min-height: 0px;
    }

    .compact-form {
        transform: scale(0.8);
        transform-origin: left;
    }

    .modal-flex-height {
        max-height: 40px;
    }

    .searchbar {
        margin-right: 100px;
        max-width: 30%;
    }

    .datatable {
        background-color: #FFFFFF;
        color: #FFFFFF;
    }

    .modal-header,
    .modal-footer {
        padding: 15px;
        display: flex;
    }

    .modal-header {
        border-bottom: 1px solid #eeeeee;
        justify-content: space-between;
        font-weight: bold;
    }

    .modal-footer {
        border-top: 1px solid #eeeeee;
        justify-content: flex-end;
    }

    .modal-body {
        position: relative;
        padding: 15px;
    }

    .create-button {
        float: initial;
    }

    .headline {
        font-weight: bold;
    }

    .table-left-align {
        text-align: left;
    }

    .table-middle {
        vertical-align: bottom;
    }

    .inner {
        vertical-align: middle;
    }

    .button-panel {
        padding-right: 15px;
    }

    .is-centering {
        vertical-align: middle;
    }

    .congatec-gray {
        color: rgb(70, 70, 75);
    }
</style>



// WEBPACK FOOTER //
// src/App.vue